import { OutlinedInput, styled } from "@mui/material";

const StyledTextField = styled(OutlinedInput)(({ theme }) => {
  return {
    borderRadius: theme.shape.borderRadius,
    "&.Mui-focused": {
      boxShadow: "0px 0px 0px 4px #F5F5F5",
    },
    "&.Mui-error": {
      "&.Mui-focused": {
        boxShadow: "0px 0px 0px 4px #FEE4E2",
      },
      "& .MuiOutlinedInput-notchedOutline ": {
        borderColor: "#FDA29B",
      },
    },
    "&.Mui-disabled": {
      "&.Mui-focused": {
        boxShadow: "0px 0px 0px 4px #FEE4E2",
      },
      "& .MuiOutlinedInput-notchedOutline ": {
        borderColor: "#DBDDE0",
        // backgroundColor: "#F9FAFB",
      },
      // The outline (a fieldset drawn after the field) sits over it, so
      // everything inside is lifted above it: the input, a textarea, a
      // select's value (a div, not an input), its arrow icon and adornments
      // (e.g. the phone country code)
      "& .MuiInputBase-input": {
        zIndex: 1,
        color: "#667085",
        WebkitTextFillColor: "#667085",
      },
      "& .MuiSelect-icon, & .MuiInputAdornment-root": {
        zIndex: 1,
      },
    },
    "& input ": {
      padding: theme.spacing(1.25),
      fontSize: 16,
      fontWeight: 400,
      lineHeight: theme.spacing(3),
      "&::placeholder": {
        color: "#70737B",
      },
    },
    "& .MuiOutlinedInput-notchedOutline ": {
      borderColor: "#DBDDE0",
    },
  };
});

export default StyledTextField;
